import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookingsState } from "./types";
import { fetchBookings } from "./bookings-thunk";
import { stat } from "fs";
import { ErrorType } from "@/shared/types";

const initialState: BookingsState = {
    bookings: [],
    bookingsError: null,
    isBookingsLoading: false,
    isBookingsFirstLoad: true,
    page: 1,
    limit: 50,
    totalPages: 0,
}

const bookingsSlice = createSlice({
    name: 'bookings',
    initialState,
    reducers: {
        nextPage: (state) => {
            if (state.page < state.totalPages) {
                state.page += 1
            }
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload
        },
        reset: (state) => {
            state.bookings = []
            state.bookingsError = null
            state.isBookingsLoading = false
            state.isBookingsFirstLoad = true
            state.page = 1
            state.limit = 50
            state.totalPages = 0
        }
    },
    extraReducers(builder) {
        builder.addCase(fetchBookings.pending, (state) => {
            state.isBookingsLoading = true
        })
        builder.addCase(fetchBookings.fulfilled, (state, action) => {
            const loadedPage = action.payload.bookings.map((booking) => ({ book: booking.book, updatedAt: booking.updated_at }))
            // Первая страница — начало списка, поэтому она заменяет содержимое, а не
            // дописывается: иначе повторная загрузка (обновление списка после отмены
            // брони) задваивает строки и оставляет на экране устаревшую карточку.
            // Сравнивается запрошенная страница, а не текущая: они расходятся, если
            // ответ пришёл после того, как страницу успели переключить.
            state.bookings = action.payload.requestedPage === 1 ? loadedPage : [...state.bookings, ...loadedPage]
            state.isBookingsLoading = false
            state.isBookingsFirstLoad = false
            state.bookingsError = null
        })
        builder.addCase(fetchBookings.rejected, (state, action) => {
            state.bookingsError = action.error as ErrorType
            state.isBookingsLoading = false
        })
    },
})

export default bookingsSlice.reducer
export const { setPage, nextPage, reset } = bookingsSlice.actions